import React from 'react'

export default function ControlLabel({ children }) {
    return (
        <label style={{ display: 'block' }}>
            {children}
        </label>
    )
}